var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDegLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2016_3448)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.71936 7.28121C1.64952 7.21155 1.5941 7.12878 1.5563 7.03767C1.51849 6.94655 1.49902 6.84887 1.49902 6.75021C1.49902 6.65156 1.51849 6.55388 1.5563 6.46276C1.5941 6.37165 1.64952 6.28888 1.71936 6.21921L7.71936 0.219215C7.86019 0.078385 8.0512 -0.000732422 8.25036 -0.000732422C8.44953 -0.000732422 8.64053 0.078385 8.78136 0.219215C8.92219 0.360045 9.00131 0.551051 9.00131 0.750215C9.00131 0.949379 8.92219 1.14038 8.78136 1.28121L4.06086 6.00021H18.7504C19.7449 6.00021 20.6988 6.3953 21.402 7.09856C22.1053 7.80183 22.5004 8.75565 22.5004 9.75021V21.7502C22.5004 21.9491 22.4213 22.1399 22.2807 22.2805C22.14 22.4212 21.9493 22.5002 21.7504 22.5002C21.5515 22.5002 21.3607 22.4212 21.22 22.2805C21.0794 22.1399 21.0004 21.9491 21.0004 21.7502V9.75021C21.0004 9.15348 20.7633 8.58118 20.3414 8.15922C19.9194 7.73727 19.3471 7.50021 18.7504 7.50021H4.06086L8.78136 12.2192C8.8511 12.2889 8.90641 12.3717 8.94415 12.4628C8.98189 12.5539 9.00131 12.6516 9.00131 12.7502C9.00131 12.8488 8.98189 12.9465 8.94415 13.0376C8.90641 13.1287 8.8511 13.2115 8.78136 13.2812C8.71163 13.3509 8.62885 13.4063 8.53774 13.444C8.44663 13.4817 8.34898 13.5012 8.25036 13.5012C8.15175 13.5012 8.0541 13.4817 7.96299 13.444C7.87188 13.4063 7.7891 13.3509 7.71936 13.2812L1.71936 7.28121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2016_3448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDegLeft);
export default __webpack_public_path__ + "static/media/arrow-deg-left.64926fb59feffa14f68da0506aad2f9d.svg";
export { ForwardRef as ReactComponent };